import React, { useState } from "react";
import { useParams } from "react-router";
import AliianceManagerLayout from "../../../components/layouts/AliianceManagerLayout";
import CreateExecutive from "../../../components/CreateExecutive";
import Breadcrumb from "../../../components/common/Breadcrumb";
import VendorSelect from "./VendorSelect";

// Alliance Manager: add an executive (SPOC) under a vendor.
// Vendor comes from the route (vendor details page) or is picked from the dropdown (side menu).
const AddVendorExecutivePage = () => {
  const { id } = useParams();
  const [vendor, setVendor] = useState(null);
  const vendorId = id || vendor?.id;

  const breadcrumbs = id
    ? [
        { title: "Home", link: "/alliance-manager/dashboard", isActive: true },
        { title: "Vendors", link: "/alliance-manager/vendors", isActive: true },
        {
          title: "Vendor Details",
          link: `/alliance-manager/vendors/details/${id}`,
          isActive: true,
        },
        { title: "Add Executive", isActive: false },
      ]
    : [
        { title: "Home", link: "/alliance-manager/dashboard", isActive: true },
        { title: "Executives Lists", link: "/alliance-manager/executive", isActive: true },
        { title: "Add Executive", isActive: false },
      ];

  const vendorPicker = !id && (
    <VendorSelect value={vendor} onChange={setVendor} />
  );

  return (
    <AliianceManagerLayout>
      {vendorId ? (
        // key remounts the form so vendor-mapped lookups and fields reset on vendor change
        <CreateExecutive
          key={vendorId}
          vendorId={vendorId}
          breadcrumbs={breadcrumbs}
          vendorPicker={vendorPicker}
        />
      ) : (
        <div id="main" role="main">
          <div id="content">
            <Breadcrumb items={breadcrumbs} />
            {vendorPicker}
          </div>
        </div>
      )}
    </AliianceManagerLayout>
  );
};

export default AddVendorExecutivePage;
